import React, { useEffect, useRef, useState } from "react";
import "./css/app1.css";
import AboutImg from "./images/aboutnew-033.jpg";

export default function AboutUsSection() {
  const sectionRef = useRef(null);
  const [startCount, setStartCount] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setStartCount(true);
            observer.unobserve(entry.target); // run once
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <>
      <div ref={sectionRef} className="col-md-12 aboutMain scroll-appear">
        <div className="col-md-6 containArea">
          <div className="aboutHeading">
            <h1>Why Choose Raj Digital Marketing?</h1>
          </div>
          <div className="aboutPara">
            <p>
              At Raj Digital Marketing, we understand the unique needs of every
              business. Our expert team crafts customized digital strategies
              that drive measurable results. We focus on transparency,
              communication, and delivering success for your brand.
            </p>
          </div>
          <div className="aboutPara2">
            <p>
              What sets Raj Digital Marketing apart is our commitment to
              excellence and client success. We work closely with you to
              understand your business goals and tailor our services to match.
              From SEO to content creation and social media management, we
              leverage the latest tools and industry best practices to enhance
              your brand’s visibility. Our data-driven approach ensures that
              every strategy is optimized for optimal performance. With a focus
              on continuous improvement, we guarantee results that align with
              your vision. Choose Raj Digital Marketing for a proactive,
              results-oriented partnership focused on your growth.
            </p>
          </div>
        </div>

        <div className="col-md-6 mainImg">
          <div className="aboutImg">
            <img src={AboutImg} alt="About Raj Digital Marketing" />
          </div>
        </div>
      </div>

      {/* Counter Section */}
      <div className="col-md-12 main2">
        <div className="mainbox">
          <CounterBox target={100} label="PROJECTS COMPLETED" start={startCount} />
          <CounterBox target={30} label="SATISFIED PARTNERS" start={startCount} />
          <CounterBox target={50} label="CAMPAIGNS RUNNING" start={startCount} />
          <CounterBox target={20} label="BRANDS SUPPORTED" start={startCount} />
          <CounterBox target={95} label="CLIENT RETENTION" start={startCount} suffix="%" />
        </div>
      </div>
    </>
  );
}

// ✅ Counter component (smooth easing animation)
const CounterBox = ({ target, label, start, suffix = "+" }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!start) return;

    let startValue = 1;
    const duration = 2000; // total time for count (2s)
    const frameRate = 1000 / 60; // 60fps
    const totalFrames = Math.round(duration / frameRate);
    const easeOut = (t) => 1 - Math.pow(1 - t, 3);

    let frame = 0;
    const counter = setInterval(() => {
      frame++;
      const progress = easeOut(frame / totalFrames);
      setCount(Math.round(target * progress));
      if (frame === totalFrames) clearInterval(counter);
    }, frameRate);

    return () => clearInterval(counter);
  }, [start, target]);

  return (
    <div className="col-md-2 Area1">
      <div className="mainbox1">
        <div className="number">
          {count}
          {suffix}
        </div>
        <div className="text">{label}</div>
      </div>
    </div>
  );
};
